import { getStatusColor } from '../../helpers/getStatusColor';
import { getValueOrDefault } from '../../helpers/getvalueOrDefault';
import type { ChartResponse } from '../../redux/config/chart-data';
import type { WidgetConfigurationData } from '../../redux/config/widgetApi';
import type { PieChartValues } from '../../shared/widget-data.interfaces';
import type { IDataCommand } from '../data-transformer.interface';

export class BuildPieChartValuesByValues
  implements IDataCommand<Array<ChartResponse>, WidgetConfigurationData, Array<PieChartValues>>
{
  process(data: Array<ChartResponse>, config: WidgetConfigurationData): Array<PieChartValues> {
    const widgetConfigValues = config.widgetConfig;
    return data.map((item, index) => {
      const field = getValueOrDefault(item.field, '[none]');
      let color = widgetConfigValues && widgetConfigValues.colors && widgetConfigValues.colors[field];
      if (!color) {
        color = getStatusColor(index);
      }
      return {
        field,
        value: Number(item.value),
        color,
      };
    });
  }
}
